
<!-- 赋能企业数字化转型 -->
<template>
  <div class="numberZx">
  <div class="newlist">
    <!-- <div v-for="(item, index) in imgData" :key="index" :class="'newlist_item wow' + (index > 2?'slideInLeft':'slideInRight')" :data-wow-duration="index + 's'">
              <img :width="item.w" :height="item.h" :src="item.srcUrl" alt="">
            </div> -->
      <div class="newlist_item wow bounceInLeft" style="margin-bottom: 22px;" data-wow-duration="2s">
        <img :width="imgData[0].w" :height="imgData[0].h" :src="imgData[0].srcUrl" alt="">
      </div>
      <div class="newlist_item wow bounceInDown" style="margin-bottom: 22px;" data-wow-duration="2s">
        <img :width="imgData[1].w" :height="imgData[1].h" :src="imgData[1].srcUrl" alt="">
      </div>
      <div class="newlist_item wow bounceInRight" style="margin-bottom: 22px;" data-wow-duration="2s">
        <img :width="imgData[2].w" :height="imgData[2].h" :src="imgData[2].srcUrl" alt="">
      </div>
      <div class="newlist_item wow bounceInLeft" data-wow-duration="2s">
        <img :width="imgData[3].w" :height="imgData[3].h" :src="imgData[3].srcUrl" alt="">
      </div>
      <div class="newlist_item wow bounceInUp" data-wow-duration="2s">
        <img :width="imgData[4].w" :height="imgData[4].h" :src="imgData[4].srcUrl" alt="">
      </div>
      <div class="newlist_item wow bounceInRight" data-wow-duration="2s">
        <img :width="imgData[5].w" :height="imgData[5].h" :src="imgData[5].srcUrl" alt="">
      </div>


      <div class="numberZx_dyimg">
        <img width="379" height="355" :src="require('../../assets/image/indexqiye/5.png')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
// import { showNumber, packageListHomepage } from "@/api/projectSquare/xmgc";
export default {
  name: 'numberZx',
  data() {
    return {
      imgData: [
        { id: 0, srcUrl: require('../../assets/image/indexqiye/1.png'), w: 387, h: 178 },
        { id: 1, srcUrl: require('../../assets/image/indexqiye/2.png'), w: 387, h: 178 },
        { id: 2, srcUrl: require('../../assets/image/indexqiye/3.png'), w: 387, h: 178 },
        { id: 3, srcUrl: require('../../assets/image/indexqiye/4.png'), w: 588, h: 354 },
        { id: 4, srcUrl: require('../../assets/image/indexqiye/6.png'), w: 286, h: 354 },
        { id: 5, srcUrl: require('../../assets/image/indexqiye/7.png'), w: 286, h: 354 },
      ]


    };
  },
  created() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        live: false
      }).init()
    });
  },
  methods: {

  },
};
</script>

<style scoped>
.numberZx {}

.newlist {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}

.numberZx_dyimg {
  position: absolute;
  bottom: -148px;
  left: 0;
  z-index: 3;
}

.newlist_item {
  box-shadow: 0px 2px 6px 0px rgba(0, 38, 60, 0.1);
  border-radius: 4px 4px 4px 4px;
  position: relative;
  box-sizing: border-box;
  /* margin-top: 15px; */
  /* margin-left: 15px; */
  cursor: pointer;
  transition: 1s;
}

.newlist_item:hover {
  transform: scale(1.08);
  z-index: 3;
  box-shadow: 0px 2px 20px 0px #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/numberZx.vue